import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onefourtempotravelleronrentinpune() {



  const cardData = {
"keyword": "14 Seater Tempo Traveller on Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable 14 Seater Tempo Traveller on Rent in Pune for family vacations, corporate travel, weddings, airport transfers, pilgrimage tours, and outstation trips. Our comfortable AC Tempo Travellers with pushback seats and experienced drivers ensure safe, spacious, and affordable group travel across Pune and nearby destinations.",

 "topPlaces": [
    {
      "title": "Ajanta Caves",
      "description": "Ajanta Caves are UNESCO World Heritage rock-cut Buddhist caves famous for ancient paintings, sculptures, and historical architecture. It is a popular long-distance Tempo Traveller group tour from Pune."
    },
    {
      "title": "Ellora Caves",
      "description": "Ellora Caves near Aurangabad are known for magnificent rock-cut temples including Kailasa Temple, attracting history lovers and group tourists from Pune."
    },
    {
      "title": "Bhimashankar",
      "description": "Bhimashankar is a famous Jyotirlinga temple surrounded by dense forests and wildlife sanctuary, ideal for spiritual group travel and trekking trips from Pune."
    },
    {
      "title": "Tamhini Ghat",
      "description": "Tamhini Ghat is a scenic monsoon destination near Pune known for waterfalls, misty mountains, and lush greenery, perfect for weekend Tempo Traveller trips."
    },
    {
      "title": "Harihareshwar",
      "description": "Harihareshwar is a peaceful beach destination known as 'Dakshin Kashi', famous for temples, clean beaches, and relaxing group travel experiences."
    },
    {
      "title": "Diveagar Beach",
      "description": "Diveagar Beach is a clean and less crowded beach near Pune known for coconut trees, calm waters, and peaceful group outings."
    },
    {
      "title": "Malshej Ghat",
      "description": "Malshej Ghat is a beautiful mountain pass famous for waterfalls, flamingos, foggy weather, and monsoon road trips from Pune."
    },
    {
      "title": "Kolad",
      "description": "Kolad is an adventure destination known for river rafting on the Kundalika River, camping, and outdoor group activities from Pune."
    },
    {
      "title": "Pawna Lake",
      "description": "Pawna Lake is a popular camping and weekend getaway spot near Lonavala known for lakeside tents, bonfires, and scenic sunset views."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal beach destination near Pune famous for clean beaches, forts, seafood, and weekend group tours."
    }
  ],



services: [
  {
    name: "14 Seater Bus on Rent in Pune",
    description: "14 seater bus on rent in Pune service provides comfortable and spacious transportation for family tours, corporate outings, airport transfers, picnic trips, and outstation travel requirements. Well-maintained vehicles ensure smooth highway journeys suitable for local and long-distance group transportation. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 14 seater bus reservations."
  },
  {
    name: "14 Seater Tempo Traveller on Rent Pimpri Chinchwad",
    description: "14 seater Tempo Traveller on rent Pimpri Chinchwad service offers dependable transportation for family vacations, corporate travel, airport transfers, and group outings from Pimpri Chinchwad Pune. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for long-distance journeys. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Hire 14 Seater Minibus for Picnic",
    description: "Hire 14 seater minibus for picnic service provides comfortable transportation for school outings, family gatherings, office picnics, one-day trips, and sightseeing tours. Spacious seating and smooth travel performance ensure pleasant journeys suitable for group passengers. Professional drivers ensure safe driving and punctual pickup services throughout the picnic route. Pickup services are available from homes, schools, colleges, offices, hotels, and residential societies across Pune. Flexible booking options allow convenient picnic minibus reservations."
  },
  {
    name: "14 Seater Bus Rental in Pune",
    description: "14 seater bus rental in Pune service provides reliable transportation for weddings, educational tours, family trips, corporate events, and tourist travel requirements. Comfortable interiors and spacious seating ensure smooth travel experiences suitable for local and outstation journeys. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 14 seater bus rental reservations."
  },
  {
    name: "13 Seater Bus Hire in Pune",
    description: "13 seater bus hire in Pune service offers economical and spacious transportation for group tours, airport transfers, educational travel, family functions, and local sightseeing requirements. Comfortable seating ensures pleasant travel experiences suitable for small and medium-sized passenger groups. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 13 seater bus reservations."
  },
  {
    name: "14 Seater Mini Bus Rental for Corporate",
    description: "14 seater mini bus rental for corporate service provides professional transportation for employee travel, office meetings, conferences, industrial visits, and team outings. Spacious vehicles ensure comfortable travel experiences suitable for business passengers and executive teams. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from offices, IT parks, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate mini bus reservations."
  },
  {
    name: "14 Seater Tempo Traveller Per KM Rate in Pune",
    description: "14 seater Tempo Traveller per km rate in Pune service offers transparent and affordable transportation solutions for local travel, outstation tours, family trips, and corporate journeys. Comfortable vehicles ensure smooth highway travel suitable for group passengers and long-distance travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "14 Seater AC Bus Rental for Picnic",
    description: "14 seater AC bus rental for picnic service provides comfortable air-conditioned transportation for school outings, family gatherings, office trips, and sightseeing tours. Spacious seating and cooling systems ensure pleasant travel experiences suitable for all age groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, schools, colleges, offices, hotels, and residential societies across Pune. Flexible booking options allow convenient AC picnic bus reservations."
  },
  {
    name: "13 Seater Non AC Bus on Rent",
    description: "13 seater non AC bus on rent service offers economical transportation for local travel, school trips, family outings, employee transport, and short-distance group journeys. Spacious interiors ensure comfortable seating suitable for affordable travel requirements. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "Pune to Goa 14 Seater AC Bus Rental",
    description: "Pune to Goa 14 seater AC bus rental service offers premium transportation for beach vacations, family tours, corporate outings, and tourist travel from Pune. Spacious air-conditioned buses ensure comfortable overnight and long-distance journeys with luggage space suitable for group passengers. Professional chauffeurs ensure safe highway driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar 14 Seater Tempo Traveller",
    description: "Pune to Mahabaleshwar 14 seater Tempo Traveller service provides comfortable hill station transportation for family vacations, sightseeing tours, and weekend getaway trips. Spacious seating and smooth suspension ensure pleasant ghat road travel experiences for all passengers. Professional drivers ensure safe driving and reliable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Pune to Shirdi 14 Seater Bus on Rent",
    description: "Pune to Shirdi 14 seater bus on rent service offers dependable transportation for Sai Baba darshan tours, pilgrimage travel, family trips, and spiritual journeys from Pune. Spacious buses ensure comfortable highway travel suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi bus reservations."
  },
  {
    name: "Pune to Shirdi Tempo Traveller Hire",
    description: "Pune to Shirdi Tempo Traveller hire service provides reliable transportation for temple visits, family darshan tours, pilgrimage groups, and spiritual travel from Pune. Comfortable seating and luggage space ensure smooth highway journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Pune Airport to Lonavala Tempo Traveller on Rent",
    description: "Pune Airport to Lonavala Tempo Traveller on rent service provides direct airport pickup transportation for tourists, families, and corporate groups traveling to Lonavala from Pune Airport. Spacious vehicles ensure comfortable luggage handling and smooth expressway journeys suitable for hill station travel. Professional chauffeurs ensure timely airport pickup and safe driving services throughout the route. Pickup services are available directly from airport terminals with flexible scheduling options. Convenient booking options allow hassle-free Lonavala traveller reservations."
  },
  {
    name: "Pune Airport to Shirdi Tempo Traveller on Rent",
    description: "Pune Airport to Shirdi Tempo Traveller on rent service offers direct airport transportation for devotees and tourists planning Shirdi Sai Baba temple visits from Pune Airport. Comfortable vehicles ensure smooth long-distance travel suitable for families, senior citizens, and pilgrimage groups. Professional chauffeurs ensure punctual airport pickup and reliable transportation services throughout the journey. Pickup services are available directly from airport terminals with flexible timing options. Convenient booking options allow easy airport traveller reservations."
  },
  {
    name: "14 Seater Tempo Traveller Rate Per KM in Pune",
    description: "14 seater Tempo Traveller rate per km in Pune service provides affordable and transparent transportation solutions for local travel, outstation trips, airport transfers, and family tours. Spacious vehicles ensure comfortable highway journeys suitable for group passengers and tourist travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "14 Seater Tempo Traveller Hire in Pimpri Chinchwad",
    description: "14 seater Tempo Traveller hire in Pimpri Chinchwad service offers reliable transportation for corporate travel, airport transfers, family vacations, and group outings from Pimpri Chinchwad Pune. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial areas across Pimpri Chinchwad. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "14 Seater Tempo Traveller on Rent",
    description: "14 seater Tempo Traveller on rent service provides spacious and comfortable transportation for family trips, sightseeing tours, airport transfers, corporate outings, and outstation journeys. Comfortable seating and luggage space ensure smooth highway travel suitable for group passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "14 Seater Tempo Traveller Hire",
    description: "14 seater Tempo Traveller hire service offers dependable transportation for educational tours, wedding travel, business meetings, pilgrimage trips, and family vacations. Spacious interiors ensure comfortable journeys suitable for long-distance and local travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient traveller hire reservations."
  },
  {
    name: "14 Seater Tempo Traveller Booking",
    description: "14 seater Tempo Traveller booking service provides easy and reliable transportation solutions for group tours, airport transfers, sightseeing trips, wedding travel, and outstation journeys. Comfortable seating and spacious interiors ensure pleasant travel experiences for families and tourists. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller booking reservations."
  },
  {
    name: "14 Seater Tempo Traveller Rentals",
    description: "14 seater Tempo Traveller rentals service offers economical and comfortable transportation for local travel, corporate outings, family functions, school trips, and long-distance journeys. Spacious vehicles ensure smooth highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient traveller rental reservations."
  },
  {
    name: "AC 14 Seater Tempo Traveller",
    description: "AC 14 seater Tempo Traveller service provides premium air-conditioned transportation for family vacations, business travel, airport transfers, sightseeing tours, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Luxury 14 Seater Tempo Traveller",
    description: "Luxury 14 seater Tempo Traveller service offers stylish and spacious transportation with premium interiors, comfortable pushback seating, and luxury amenities for weddings, VIP travel, corporate events, and family vacations. Luxury vehicles ensure smooth highway travel suitable for executive and tourist travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, banquet halls, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "Cheap 14 Seater Tempo Traveller",
    description: "Cheap 14 seater Tempo Traveller service provides affordable transportation for local travel, educational tours, family outings, pilgrimage journeys, and airport transfers. Spacious seating ensures comfortable travel suitable for budget-friendly group transportation requirements. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient budget traveller reservations."
  },
  {
    name: "Outstation 14 Seater Tempo Traveller",
    description: "Outstation 14 seater Tempo Traveller service offers dependable long-distance transportation for Goa trips, Mahabaleshwar tours, Shirdi darshan, Nashik travel, and family vacations from Pune. Spacious vehicles ensure comfortable seating and smooth highway journeys suitable for tourist and pilgrimage travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation traveller reservations."
  },
  {
    name: "14 Seater Traveller on Rent",
    description: "14 seater traveller on rent service provides spacious transportation for family travel, office outings, sightseeing tours, wedding functions, and outstation group journeys. Comfortable seating and luggage space ensure pleasant travel experiences suitable for local and long-distance routes. Professional drivers ensure safe transportation and dependable pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller 14 Seater Price",
    description: "Tempo Traveller 14 seater price service offers transparent and economical transportation solutions for airport transfers, family vacations, corporate travel, educational tours, and tourist journeys. Spacious interiors ensure comfortable seating suitable for all passenger groups and long-distance travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient traveller reservations."
  }
],

tableData: [
  ["14 Seater Bus on Rent in Pune", "14 Seater Tempo Traveller on Rent Pimpri Chinchwad"],
  ["Hire 14 Seater Minibus for Picnic", "14 Seater Bus Rental in Pune"],
  ["13 Seater Bus Hire in Pune", "14 Seater Mini Bus Rental for Corporate"],
  ["14 Seater Tempo Traveller Per KM Rate in Pune", "14 Seater AC Bus Rental for Picnic"],
  ["13 Seater Non AC Bus on Rent", "Pune to Goa 14 Seater AC Bus Rental"],
  ["Pune to Mahabaleshwar 14 Seater Tempo Traveller", "Pune to Shirdi 14 Seater Bus on Rent"],
  ["Pune to Shirdi Tempo Traveller Hire", "Pune Airport to Lonavala Tempo Traveller on Rent"],
  ["Pune Airport to Shirdi Tempo Traveller on Rent", "14 Seater Tempo Traveller Rate Per KM in Pune"],
  ["14 Seater Tempo Traveller Hire in Pimpri Chinchwad", "14 Seater Tempo Traveller on Rent"],
  ["14 Seater Tempo Traveller Hire", "14 Seater Tempo Traveller Booking"],
  ["14 Seater Tempo Traveller Rentals", "AC 14 Seater Tempo Traveller"],
  ["Luxury 14 Seater Tempo Traveller", "Cheap 14 Seater Tempo Traveller"],
  ["Outstation 14 Seater Tempo Traveller", "14 Seater Traveller on Rent"],
  ["Tempo Traveller 14 Seater Price", "14 Seater Bus on Rent in Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 14 Seater Tempo Traveller on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 14 seater Tempo Traveller rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable 14 Seater Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 14 seater Tempo Traveller on rent in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our 14 seater Tempo Traveller rental service in Pune operates 24 hours for airport transfers, outstation tours, weddings, family vacations, corporate events, and pilgrimage travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All 14 seater Tempo Travellers provided by Aaradhya Travels are air-conditioned, spacious, clean, and regularly sanitized to ensure comfortable travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Outstation Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day holiday packages, and flexible outstation travel plans according to customer requirements."
      },
      {
        WhyChooseheading: "Ideal Vehicle for Family & Group Travel",
        WhyChoosedescription: "The 14 seater Tempo Traveller is ideal for family vacations, tourist groups, office outings, wedding travel, school trips, and pilgrimage journeys from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Long Distance Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with city and highway routes, ensuring safe driving, smooth journeys, and timely travel for every group trip."
      }
    ]
  };

  const faqData = [
    { question: "What is 14 seater Tempo Traveller on rent in Pune?", answer: "14 seater Tempo Traveller rental service in Pune provides comfortable group transportation for family trips, corporate travel, outstation tours, and holiday journeys." },
    { question: "Is 14 seater Tempo Traveller booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 14 seater Tempo Traveller rental service in Pune." },
    { question: "Can I book 14 seater Tempo Traveller for outstation travel?", answer: "Yes, customers can book 14 seater Tempo Travellers for outstation tours, hill stations, pilgrimage journeys, and long-distance travel." },
    { question: "Do you provide Tempo Traveller for corporate events?", answer: "Yes, Aaradhya Travels provides 14 seater Tempo Travellers for corporate tours, conferences, office outings, and employee travel." },
    { question: "Are all 14 seater Tempo Travellers air-conditioned?", answer: "Yes, all 14 seater Tempo Travellers are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Tempo Traveller online in Pune?", answer: "Yes, customers can easily book 14 seater Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Traveller for family and wedding travel?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for family vacations, weddings, and group travel." },
    { question: "Are 14 seater Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." },
    { question: "Do you provide pickup from Pune Airport and railway station?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Shubham Pawar",
    feedback:
      "We planned a short getaway with friends and used a 14 Seater Tempo Traveller on rent in Pune. The ride was smooth, the vehicle was clean, and everyone enjoyed traveling together comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rohini Kulkarni",
    feedback:
      "A 14 Seater Tempo Traveller rental in Pune made our family outing very convenient. The seating was comfortable, the journey was safe, and the overall experience was very pleasant.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14 Seater Tempo Traveller on Rent",
  "image": "https://www.aaradhyatravels99.com/assets/images/14-seater-tempo-traveller-on-rent.jpg",
  "description": "Book 14 Seater Tempo Traveller on rent in Pune with Aaradhya Travels for family trips, corporate tours, airport transfers, picnics, weddings, and outstation travel. Affordable AC and Non-AC tempo traveller available for Goa, Mahabaleshwar, Shirdi, Lonavala and more.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3475"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/14-seater-tempo-traveller-on-rent"
  }
};





  return (
    <div>
<Helmet>
  <title>
    14 Seater Tempo Traveller on Rent in Pune | AC Mini Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 14 Seater Tempo Traveller on rent in Pune with Aaradhya Travels. Affordable AC and Non-AC traveller available for Goa, Mahabaleshwar, Shirdi, Lonavala, corporate trips, picnics, airport transfers, and family tours."
  />

  <meta
    name="keywords"
    content="14 Seater Bus on Rent in Pune, 14 seater tempo traveller on rent Pimpri Chinchwad, Hire 14 Seater Minibus for Picnic, 14 Seater bus rental in Pune, 13 Seater bus hire in Pune, 14 seater mini bus rental for Corporate, 14 seater tempo traveller per km rate in Pune, 14 Seater Ac Bus Rental for Picnic, 13 Seater Non Ac Bus on rent, Pune to Goa 14 Seater ac bus rental, Pune to Mahabaleshwar 14 Seater tempo Traveller, Pune to shirdi 14 seater bus on rent, Pune to Shirdi Tempo Traveller Hire, Pune Airport to Lonavala Tempo Traveller on Rent, Pune Airport to Shirdi Tempo Traveller on Rent, 14 seater tempo traveller rate per km in pune, 14 seater tempo traveller hire in pimpri"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onefourtempotravelleronrentinpune;